import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Header from '../../Core/Header';
import { Section } from '../../Core/Section';
import { assignCallingPersonServiceReminder, assignServiceBoyReminder, employeeList, getListServiceReminder, getServiceBoyList, storeTypeList } from '../../Services/Operations/ProductAPI';
import { toast } from 'react-toastify';

const ServiceRequentNotification = () => {
      const navigate = useNavigate();
              const token = useSelector((state) => state.user.token);

                const [employee, setEmployee] = useState([]);
                const [currentService,setCurrentService]=useState(null)
                  const [currentServiceAssign,setCurrentServiceAssign]=useState(null)
                const [serviceList,setServiceList]=useState([])
                const[serviceBoys,setServiceBoys]=useState([])
                const[storeOwner,setStoreOwner]=useState([])
                const [selectedServiceBoy,setSelectedServiceBoy]=useState(null)
                const[pickupDateTime,setPickupDateTime]=useState(null)
                const[pickupLocation,setPickupLocation]=useState("")
                const[alternateNumber,setAlternateNumber]=useState('')


                const dateFormat=(date)=>{
                const formattedDate = new Date(date).toLocaleDateString(
  "en-IN",
  {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric"
  }
)
return formattedDate
}

                const handleGetServiceList=async()=>{
                  try {
                    const response=await getListServiceReminder(token)
                    console.log(response);
                    if(response.status===200){
                      setServiceList(response.data)
                    }
                    
                  } catch (error) {
                    console.log(error);
                    
                  }
                }

                 const fetchEmployeeList = async () => {
                      try {
                        const response = await employeeList(token);
                     
                        console.log(response);
                       let callerList=  response.filter(employee =>
                                employee.roles.some(role => role.id === 6)
                                        );
                       setEmployee(callerList)
                       console.log(callerList);
                       
                      } catch (error) {
                        console.error("Error:", error);
                      }
                    };

                    const handleAssignCallerPerson=async(id)=>{
                        try {setCurrentService(null)
                          let data={
                             serviceScheduleId:currentService,
                            callingPersonEmployeeId:id,
                            token
                          }
                          const response=await assignCallingPersonServiceReminder(data)
                          console.log(response);
                          
                            console.log(id);
                            if(response.status===200){
                              toast.success(response.data.message)
                              handleGetServiceList()
                            }
                            
                        } catch (error) {
                            console.log(error);
                            
                        }
                    }

                    const fetchServieBoys=async()=>{
                                  if(!token){
                                      navigate('/login')
                                      return;
                                  }
                          
                                  try {
                                      const response = await getServiceBoyList(token)
                                      console.log("serice boy  List: ", response);
                                      setServiceBoys(response)
                                      
                                  } catch (error) {
                                      console.log(error);
                                      
                                  }
                              }
                    const fetchStoreOwner = async () => {
                          try {
                            const response = await storeTypeList(token);
                            console.log(response);
                            
                            setStoreOwner(response);
                          } catch (error) {
                            console.error("Error:", error);
                          }
                        };

            const handleSubmitServicePersonAssign=async()=>{
              try {
                let data={
                  id:currentServiceAssign.id,
                  pickupDateTime,
                  pickupLocation,
                  alternateNumber,
                  servicePersonId:selectedServiceBoy?.employeeId||5,
                  productId:currentServiceAssign.productDetails[0].productId,
                  serialNumber:currentServiceAssign.productDetails[0].serialNumber,
                  token
                }
                const response=await assignServiceBoyReminder(data)
                console.log(response);
                
                console.log(data);
                if(response.status===200){
                  setCurrentServiceAssign(null)
                  handleGetServiceList()
                  toast.success('Service person assigned successfully')
                }
                
              } catch (error) {
                console.log(error);
                
              }
            }

                          const [currentPage, setCurrentPage] = useState(1);
                        const itemsPerPage = 10;
                        
                        const indexOfLast = currentPage * itemsPerPage;
                        const indexOfFirst = indexOfLast - itemsPerPage;
                        
                        const currentUsers = serviceList.slice(indexOfFirst, indexOfLast);

    useEffect(() => {
       fetchEmployeeList() 
       handleGetServiceList() 
       fetchServieBoys()
       fetchStoreOwner             
    }, [])
                    
  return (
     <div id="main_content">
         <Header/>
           <div className="page">
                <Section/>
                         <div className="section-body" style={{height:"100vh",maxHeight:"100vh",overflowY:"scroll"}}>
                             <p style={{fontWeight:"bold",fontSize:"25px",width:"fit-content",borderBottom:"1px solid black",borderLeft:"4px solid red",padding:"8px"}}>Service Notification Reminder</p>
                              <div >
                                                 <table>
                                                     <tr style={{fontSize:"18px",backgroundColor:"red"}}>
                                                         <th style={{fontSize:"18px",backgroundColor:"red"}}>Id</th>
                                                         <th style={{fontSize:"18px",backgroundColor:"red"}}>Patient</th>
                                                         <th style={{fontSize:"18px",backgroundColor:"red"}}>Product</th>
                                                          <th style={{fontSize:"18px",backgroundColor:"red"}}>Serial Number</th>
                                                        
                                                         <th style={{fontSize:"18px",backgroundColor:"red"}}>Status</th>
                                                          <th style={{fontSize:"18px",backgroundColor:"red"}}>Order date</th>
                                                         <th style={{fontSize:"18px",backgroundColor:"red"}}>Service Date</th>
                                                         <th style={{fontSize:"18px",backgroundColor:"red"}}>Action</th>
                                                      
                                                     </tr>
                             
                                                    
                                                  {  currentUsers?.map((item,ind)=>(

                                                   <tr style={{fontSize:"12px",}}>
                                                         <td>{ind+1}</td>
                                                         <td>{item.customerName}</td>
                                                         <td>Product 1</td>
                                                         <td>xt-1327648d</td>
                                                         
                                                         <td>{item.status}</td>
                                                         <td>{dateFormat(item.sellDate)}</td>
                                                         <td>{dateFormat(item.serviceDate)}</td>
                                                         <td style={{position:"relative"}}>
                                                           {item.assignmentStatus==='ASSIGNED'?
                                                           <p style={{padding:"5px",borderRadius:"4px",border:"0.4px solid grey"}}>In progress</p>
                                                           :item.assignmentStatus===null?
                                                           <button onClick={()=>setCurrentService(item.id)}
                                                                style={{padding:"10px",borderRadius:"8px",backgroundColor:"#fc2f4b",color:"white",fontWeight:"600"}}>Assign Executive</button>
                                                            : item.servicePersonAssignmentStatus===null? <button onClick={()=>setCurrentServiceAssign(item)}
                                                                style={{padding:"6px",borderRadius:"5px",backgroundColor:"#7efdb7",color:"black",fontWeight:"600",fontSize:"15px"}}>Assign Service person</button>
                                                                :<p style={{padding:"5px",borderRadius:"4px",border:"0.4px solid grey",backgroundColor:"#f3ed9a"}}>Process Complete</p>
                                                              }
                                                            {currentService===item.id &&
                                                            <div style={{position:'absolute',zIndex:99999999,width:"300px",height:"300px",borderRadius:"10px",backgroundColor:"white",right:"10px",border:"0.5px solid grey",padding:"10px",borderRadius:"10px"}}>
                                                                <p style={{right:'10px',position:"absolute",cursor:"pointer"}} onClick={()=>setCurrentService(null)}>X</p>
                                                                <p>Available Caller person</p>
                                                                {
                                                                    employee.map(item=>(
                                                                        <div style={{padding:"10px",display:"flex",gap:"10px",border:"0.3px solid #5f5e5e",borderRadius:"8px",justifyContent:"space-between"}}>
                                                                            <p>{item.firstName}{"  "}{item.lastName}</p>
                                                                        <p>Ph:{item.primaryNumber}</p>
                                                                        <p onClick={()=>handleAssignCallerPerson(item.id)}
                                                                            style={{padding:"8px",backgroundColor:"#50befd",borderRadius:"6px",cursor:"pointer",color:"white",fontWeight:"600"}}>Assign</p>
                                                                            </div>
                                                                    ))
                                                                }
                                                            </div>

                                                            }

                                                            {currentServiceAssign?.id===item.id &&
                                                            <div style={{position:'absolute',zIndex:99999999,width:"300px",height:"300px",borderRadius:"10px",backgroundColor:"white",right:"10px",border:"0.5px solid grey",padding:"10px",borderRadius:"10px"}}>
                                                                <p style={{right:'10px',position:"absolute",cursor:"pointer"}} onClick={()=>setCurrentServiceAssign(null)}>X</p>
                                                                <p>Fill the form to assign service person</p>
                                                                <select 
                                                                 value={selectedServiceBoy}
                                                                 onChange={(e) => setSelectedServiceBoy(e.target.value)}>
                                                                   <option value="">Select service person</option>
                                                                 {serviceBoys.map((boy) => (
                                                                          <option key={boy.id} value={boy.id}>
                                                                         {boy.firstName}
                                                                                 </option>
                                                                                   ))}
                                                                </select>
                                                                <label>select Pickup DateTime</label>
                                                                <input type='datetime-local' value={pickupDateTime} onChange={(e)=>setPickupDateTime(e.target.value)} />
                                                                <label></label>
                                                                <input placeholder='select Pickup Location' value={pickupLocation} onChange={(e)=>setPickupLocation(e.target.value)}/>
                                                                <label></label>
                                                                <input type='number' placeholder='Alternate Number' value={alternateNumber} onChange={(e)=>setAlternateNumber(e.target.value)}/>
                                                                <button onClick={()=>handleSubmitServicePersonAssign()}
                                                                style={{padding:"10px",borderRadius:"10px",backgroundColor:"#0a39d3",color:"white",fontWeight:'600',cursor:"pointer"}}>Assign</button>
                                                                
                                                            </div>

                                                            }
                                                            
                                                         </td>
                                                         
                                                         
                                                     </tr>
                                                   ))   
                                                 }
                             
                                                 </table>

       
                                             </div>
                         </div>

                                                                                      <div className="pagination mt-3" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                             <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((prev) => prev - 1)}
    className="btn btn-primary btn-sm me-2"
  >
    Prev
                     </button>

                      <span> Page {currentPage} of {Math.ceil(serviceList.length / itemsPerPage)} </span>

                  <button
    disabled={currentPage === Math.ceil(serviceList.length / itemsPerPage)}
    onClick={() => setCurrentPage((prev) => prev + 1)}
    className="btn btn-primary btn-sm ms-2"
  >
    Next
               </button>
</div>

                  <div className="section-body">
             <footer className="footer">
               <div className="container-fluid">
                 <div className="row">
                   <div className="col-md-6 col-sm-12">
                     Copyright © 2025{" "}
                     <a href="">Technology support By - Siance Software Pvt Ltd</a>
                     .
                   </div>
                   {/* <div className="col-md-6 col-sm-12 text-md-right">
                     <ul className="list-inline mb-0">
                       <li className="list-inline-item">
                         <a href="../doc/index.html">Documentation</a>
                       </li>
                       <li className="list-inline-item">
                         <a href="javascript:void(0)">FAQ</a>
                       </li>
                       <li className="list-inline-item">
                         <a
                           href="javascript:void(0)"
                           className="btn btn-outline-primary btn-sm"
                         >
                           Buy Now
                         </a>
                       </li>
                     </ul>
                   </div> */}
                 </div>
               </div>
             </footer>
           </div>
           </div>

      
    </div>
  )
}

export default ServiceRequentNotification
